import { TripInformation, PrePostTripDetails } from '../../trip/models/trip-information.model';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IKeyValueInterface, ApplicationRouteURL } from './../../shared/config';
import { TripService } from '../../trip/models/trip.service';
import { Location } from '@angular/common';

@Component({
  selector: 'wego-driver-tripinformation',
  template: require('../views/driver-tripinformation.component.html'),
  providers: [TripService]
})
export class DriverTripInformationComponent implements OnInit {
  apiErrorMsg: string;
  sub: any;
  submitted = false;
  readMore: IKeyValueInterface[];
  isLoading: boolean;
  message: string;
  model: TripInformation;
  errorModel: IKeyValueInterface[];
  tripHashId: string;
  popupTitle: string;
  
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('validationModal') public validationModal: any;
  
  popupMsg: any;
  isSuccess: boolean;
  errorMessage: string;
  
  constructor(
    private authService: AuthService,
    private tripService: TripService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.model = new TripInformation();
    this.sub = this.activeRoute.params.subscribe((params: any) => {
      this.tripHashId = params['tripHashId'] || '';
      if (this.tripHashId != '') {
        this.GetTripInformation();
      }
    });
  }

  private GetTripInformation() {
    this.isLoading = true;
    this.tripService
      .GetTripInformationByHashId(this.tripHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.model = res.data;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public SaveTripAnswerClick(PrePostTripDetails: PrePostTripDetails) {
    if (
      PrePostTripDetails.answer == undefined ||
      PrePostTripDetails.answer == null ||
      PrePostTripDetails.answer.length == 0
    ) {
      this.popupTitle = this.translate.instant('LblWarning');
      this.popupMsg = this.translate.instant('LblAnswerEmptyError');
      this.ShowValidationModal();

      return;
    }

    this.tripService.SaveTripAnswer(PrePostTripDetails)
      .subscribe(
        (res: any) => {
          this.popupTitle = this.translate.instant('LblSuccess');
          this.popupMsg = this.translate.instant('LblAnswerSaved');
          this.ShowSuccessPopup();
        },
        (error: any) => {
          this.popupTitle = this.translate.instant('LblWarning');
          this.popupMsg = this.translate.instant('LblAnswerSavedError');
          this.ShowSuccessPopup();
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        });
  }

  public ConfirmSuccessPopup(): void {
    if (this.tripHashId != '') {
      this.GetTripInformation();
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ShowValidationModal(): void {
    this.validationModal.show();
  }

  public HideValidationModal(): void {
    this.validationModal.hide();
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driver-tripinformation.component.ts